module.exports = __webpack_public_path__ + "static/media/22769969_1629551613786690_4325421188647665993_o.3d5f3b3e.jpg";